import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { G_DRAG_AND_DROP__area_with_label } from '@/pages/page_generation/layouts/nodes/node/fields/image/_base/_drag_and_drop/G_DRAG_AND_DROP__area_with_label';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { LOCAL__ui_set_image } from '@/state/ui/_base/LOCAL__ui_set_image';
import { create_file_data, UTILS__upload } from '@/utils/utils_upload';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { DragEvent } from 'react';
import { useTranslation } from 'react-i18next';

export function DRAG_AND_DROP__image_compare__external() {
  const dispatch = use_dispatch();

  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  const { workspace_current } = use_slice_workspace(['workspace_current']);
  const { drag_and_drop__image_external_zones_show } = use_slice_ui(['drag_and_drop__image_external_zones_show']);

  /*
   * EVENTS
   */

  function onDragOver(e: DragEvent) {
    e.preventDefault();
  }

  async function onDrop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();

    await upload_file(e.dataTransfer.files);

    dispatch(LOCAL__ui_set_boolean({ key: 'drag_and_drop__image_external_zones_show', value: false }));
  }

  /*
   *
   */

  async function upload_file(files_list: FileList) {
    const file = files_list[0];
    assert_not_null(file);

    let file_data = await create_file_data(file, toast, t_base_ui);

    let image = await UTILS__upload.image_to_workspace([file_data], ENUM__image_asset_category.IMAGE, workspace_current._id);
    if (image.is_stub()) return;

    dispatch(LOCAL__ui_set_image({ key: 'grid2d_image_compare__image_a', value: image }));
  }

  function get_class_name_opacity() {
    return drag_and_drop__image_external_zones_show ? ' opacity-100 ' : ' opacity-0 ';
  }

  function is_interactive() {
    let out = true;

    if (!drag_and_drop__image_external_zones_show) {
      out = false;
    }

    return out;
  }

  function get_text() {
    let out = '';

    out = 'Drop Image Here';

    return out;
  }

  /*
   * HTML
   */

  return (
    <div
      {...{ onDragOver, onDrop }}
      className={`absolute inset-0
        bg-black/80
    ${get_class_name_opacity()}
    ${is_interactive() ? ' border border-2 border-dashed border-component-border ' : ' pointer-events-none bg-black '}
    
    `}
    >
      <G_DRAG_AND_DROP__area_with_label text={get_text()} class_name="bg-white/10" />
    </div>
  );
}
